"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineAndViewers = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Utils_1 = require("../Utils");
var SummaryTimeline_1 = require("./Timeline/SummaryTimeline");
var UseViewersListComponents_1 = require("./Viewers/UseViewersListComponents");
var commonStyles = __importStar(require("../CommonStyles.css"));
var styles = __importStar(require("./TimelineAndViewers.css"));
var LOCALSTORAGE_TIMELINE_AND_VIEWERS_TAB = "page-analytics-timeline-and-viewers-tab";
var TimelineAndViewers = function (_a) {
    var pageId = _a.pageId, timeParams = _a.timeParams, viewers = _a.viewers, noViewsComponent = _a.noViewsComponent, openSession = _a.openSession, openAuditTrailOverlay = _a.openAuditTrailOverlay;
    var _b = __read((0, Utils_1.useLocalStorageNumber)(LOCALSTORAGE_TIMELINE_AND_VIEWERS_TAB, 0), 2), tabIndex = _b[0], setTabIndex = _b[1];
    var _c = (0, SummaryTimeline_1.useSummaryTimelineComponents)({
        pageId: pageId,
        timeParams: timeParams,
        openSession: openSession,
        openAuditTrailOverlay: openAuditTrailOverlay,
    }), timelineComponent = _c.timelineComponent, timelineFilterButtons = _c.timelineFilterButtons;
    var _d = (0, UseViewersListComponents_1.useViewersListComponents)({
        viewers: viewers,
        noViewsComponent: noViewsComponent,
        timeParams: timeParams,
        openSession: openSession,
    }), viewersList = _d.viewersList, viewersFilterButtons = _d.filterButtons;
    var tabsComponents = [
        {
            tab: react_1.default.createElement(kaleidoscope_1.Tab, { key: "timeline" }, "Timeline"),
            tabPanel: react_1.default.createElement(kaleidoscope_1.TabPanel, { key: "timeline" }, timelineComponent),
            filterButtons: timelineFilterButtons,
        },
        {
            tab: react_1.default.createElement(kaleidoscope_1.Tab, { key: "viewers" }, "Viewers"),
            tabPanel: react_1.default.createElement(kaleidoscope_1.TabPanel, { key: "viewers" }, viewersList),
            filterButtons: viewersFilterButtons,
        },
    ];
    return (react_1.default.createElement("div", { className: commonStyles.largeTabbedCard },
        react_1.default.createElement(kaleidoscope_1.Tabs, { className: commonStyles.tabs, selectedIndex: tabIndex, onChange: setTabIndex },
            react_1.default.createElement(kaleidoscope_1.TabList, { className: commonStyles.tabList, "aria-label": "Timeline or Viewers selector", isBordered: true }, tabsComponents.map(function (_a) {
                var tab = _a.tab;
                return tab;
            })),
            react_1.default.createElement(kaleidoscope_1.TabPanels, { className: "".concat(commonStyles.tabPanels, " ").concat(styles.timelineAndViewersTabPanels) }, tabsComponents.map(function (_a) {
                var tabPanel = _a.tabPanel;
                return tabPanel;
            }))),
        react_1.default.createElement("div", { className: styles.filterButtons }, tabsComponents[tabIndex].filterButtons)));
};
exports.TimelineAndViewers = TimelineAndViewers;
